import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./components/ui/Toast";
import { ConfirmProvider } from "./components/ui/ConfirmDialog";
import Routes from "./Routes";
// make some chages
function App() {
  return (
    <ToastProvider>
      <ConfirmProvider>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </ConfirmProvider>
    </ToastProvider>
  );
}

export default App;
